// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  frontendEnv:{
    url:"https://stage.negozi.fastweb.it/"
  },
  backend: {
    baseUrl_backend:"https://stage.admin.negozi.fastweb.it/api/store/",
    baseUrl_utenti: "https://stage.admin.negozi.fastweb.it/api/user/",
    baseUrl_dam: "https://stage.admin.negozi.fastweb.it/api/dam/",
    baseUrl_appuntamenti:"https://stage.admin.negozi.fastweb.it/api/appointment/",
    // baseUrl_location:"http://localhost/api/location",
    baseUrl_location:"https://stage.negozi.fastweb.it/api/location",

    pathUrl: {
      appointment: {
        smartphone_collect:"admin/smartphone-collect",
        digital_coupon:"admin/digital-coupon",
        sim_collect:"admin/sim-collect",
        simple:"admin/simple",
        topic:"admin/topic"
      },
      dam:{
        document:"admin/document",
        gallery:"admin/gallery",
        image:"admin/image"
      },
      utenti:{
        permissions:"admin/permissions",
        roles:"admin/roles",
        users:"admin/users",
        authentication_controller:"auth",
      },
      store:{
        appointment_opening_closing_hours:"admin/appointment-opening-closing-hours",
        custompage:"admin/custompage",
        custompage_activitymap:"admin/custompage/activity-map",
        custompage_dealermap:"admin/custompage/dealer-map",
        customage_newsfilter:"admin/custompage/news-filter",
        custompage_shoppingmall:"admin/custompage/shopping-mall",
        reseller:"admin/custompage/reseller",
        menu:"admin/menu",
        menu_items:"admin/menu-items",
        opening_closing_hours:"admin/opening-closing-hours",
        product_service:"admin/product-service",
        promotion_event:"admin/promotion-event",
        special_opening_closing_hours:"admin/special-opening-closing-hours",
        store:"admin/store",
        store_accessory:"admin/store-accessory",
        store_manager:"admin/store-manager",
        subfooter:"admin/subfooter",
        supervisor_groups:"admin/supervisor-groups",
        list_export:"admin/emails/list-export",
        import_xml:"admin/store/import-ir-file",
        import_xml_red:"/import-xml-red",
        export_xml_red:"/export-stores-xlsx",
      }
    }
  },
  oauth2_redirect_url: "",
  google:{
    auth_url:"",
    apikeymaps: 'AIzaSyA0JGwI3KYkDgGSk2EO1kJYyz19nQ8cR1Y'
  },
  key_location_api: 'FHwr3LKagLisMqz9',
  clientId: '674162235726-5j65a37pgm49te3pk1v6k7pelsg912v3.apps.googleusercontent.com',
};